'use client';

import React from 'react';
import { usePathname } from 'next/navigation';

import BottomBarItem from './bottomBarItem';

import routes from '@/statics/routes';

const BottomBar: React.FC = () => {
  const pathname = usePathname();

  const links = [
    [routes.home],
    [
      routes.contentBankCategories,
      routes.contentBankSubCategory,
      routes.contentBankCategory,
      routes.content,
    ],
    [routes.lessons, routes.lesson],
    [routes.profile],
  ];

  const normalize = (url: string) =>
    url.replace(/\[.*?\]/g, '[id]').replace(/\/$/, '');
  const normalizedPath = normalize(pathname);
  const active = links.findIndex((routeGroup) =>
    routeGroup.some((route) => {
      const routeUrl = normalize(route.url);
      if (routeUrl.includes('[id]')) {
        const baseUrl = routeUrl.split('[id]')[0];
        return (
          normalizedPath.startsWith(baseUrl) &&
          normalizedPath.length > baseUrl.length
        );
      }
      return routeUrl === normalizedPath;
    })
  );

  const isBottombarRoute = active < links.length && active >= 0;

  return (
    <nav
      dir="rtl"
      id="navigation"
      style={{ background: 'white' }}
      className="m-auto fixed bottom-0  min-[480px]:rounded-b-[12px] right-0 left-0 z-50 flex h-20 w-full 
      items-center justify-around bg-bottom-navigation shadow-[0_-2px_4px_rgba(0,0,0,0.1)] md:h-16 max-w-[480px]"
    >
      {isBottombarRoute && (
        <div
          className={`duration-400 ease-out absolute top-0 right-0 h-1.5 `}
          style={{
            width: `${25 + active * 50}%`,
          }}
        >
          <div
            className="absolute top-1/5 left-1/2 transform -translate-x-1/2 -translate-y-1/2 h-1.5 w-14 rounded-b-lg 
          bg-[linear-gradient(0deg,var(--p500,#2145D7)_50%,rgba(255,255,255,0)_100%)] shadow-primary shadow-[0px_4px_20px_0px]"
          />
        </div>
      )}
      {links.map((link, i) => (
        <BottomBarItem
          key={link[0].title}
          title={link[0].title}
          href={link[0].url}
          active={active === i}
          isBottombarRoute={isBottombarRoute}
        />
      ))}
    </nav>
  );
};

export default BottomBar;
